export const SET_LATEST_NEWSREMINDER = "SET_LATEST_NEWS_REMINDER";

export function snoozeNews(until = 0) {
    return {
        type: SET_LATEST_NEWSREMINDER,
        time: until
    };
}
